<template>
  <BaseNavBarCTA
    class="px-sm py-md gap-xs"
    title="Ready to Refresh Your Wardrobe?"
    :description="`Rejoin with your ${latestPlan?.displayName}`"
    color="orchid">
    <template #button>
      <BaseButton
        class="w-100"
        variant="secondary"
        text="Rejoin"
        @click="beginRejoinFlow"/>
    </template>
    <template #icon>
      <SvgHangerPlus
        color="white"
        width="32"
        height="32"/>
    </template>
  </BaseNavBarCTA>
</template>

<script setup>
import BaseNavBarCTA from '@/components/navigation/BaseNavBarCTA.vue'
import { useRejoinStore } from '@/stores/rejoin.js'
import { storeToRefs } from 'pinia'
import SvgHangerPlus from '@shared/components/icons/SvgHangerPlus.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'

const { beginRejoinFlow } = useRejoinStore()
const { latestPlan } = storeToRefs(useRejoinStore())

</script>
